<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="search-container">
          <el-input
            v-model="listQuery.keywords"
            class="search-input"
            placeholder="IO No."
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="applySearch"
          />
        </div>
      </div>
    </template>

    <campaign-payment-detail-modal
      :io-number="ioNumber"
      :show="isShowCampaignDetail"
      @close="closeCampaignDetail"
    />
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../../mixins/useTablePaging'
import CampaignPaymentDetailModal from './CampaignPaymentDetailModal.vue'

export default {
  name: 'CampaignPaymentList',
  components: {
    CampaignPaymentDetailModal,
  },
  mixins: [useTablePaging],
  data() {
    return {
      isShowCampaignDetail: false,
      ioNumber: null,
    }
  },
  methods: {
    applySearch() {
      this.showCampaignDetail(this.listQuery.keywords)
    },
    showCampaignDetail(ioNumber) {
      this.ioNumber = ioNumber
      this.isShowCampaignDetail = true
    },
    closeCampaignDetail() {
      this.isShowCampaignDetail = false
      this.ioNumber = null
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.search-container {
  display:flex;
  .search-input {
    width: 400px;
    margin-right: 10px;
  }
  button {
    margin: 0 5px;
  }
}
</style>
